import { render, staticRenderFns } from "./TrancheListing2.vue?vue&type=template&id=555effe2&"
import script from "./TrancheListing2.vue?vue&type=script&lang=js&"
export * from "./TrancheListing2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports